import priceFormatter from './priceFormatter';

const sortAsc = items => items.sort((a, b) => a.sortOrder - b.sortOrder);
const structureData = offer => ({
  code: offer.code,
  offerCode: offer.offerCode,
  topTag: offer.attributes.filter(attr => attr.type === 'highlight').map(attr => attr.value),
  preTitle: offer.description?.split(' ').slice(0, 2).join(' '),
  title: offer.displayName,
  image: offer.attributes.filter(attr => attr.type === 'headerImage').map(attr => attr.value),
  headerImgDescription: offer.attributes
    .filter(attr => attr.type === 'headerImage')
    .map(attr => attr.description),
  singleTariffImage: offer.attributes
    .filter(attr => attr.type === 'singleTariffHeaderImage')
    .map(attr => attr.value),
  singleHeaderImgDescription: offer.attributes
    .filter(attr => attr.type === 'singleTariffHeaderImage')
    .map(attr => attr.description),
  imageActive: offer.attributes
    .filter(attr => attr.type === 'headerImage')
    .map(attr => attr.value.replace(/(\.[^.]+)$/i, '_Active$1')),
  contractTag: offer.attributes.filter(attr => attr.type === 'sash').map(attr => attr.value),
  price: offer.displayPrice / 100,
  afterPrice: offer?.defaultPrice ? `€${offer.defaultPrice / 100} a month thereafter` : '',
  afterPriceAmount: offer.defaultPrice / 100,
  afterPricePosition:
    offer.attributes.filter(attr => attr.type === 'afterPrice').length === 0 ? [''] : ['more-info'],
  noDiscount: offer?.displayPrice === offer?.defaultPrice,
  sash: offer.attributes.filter(attr => attr.type === 'sash').map(attr => attr.value),
  contractLength: offer?.discountDuration ? `a month` : '',
  //  price increase tagline
  priceIncreaseTagline: offer.attributes
    .filter(attr => attr.type === 'priceIncreaseTagline')
    .map(attr => attr.value),
  discountDuration: offer?.commitmentDuration ? offer.commitmentDuration : '',
  simoDiscountDuration: offer?.discountDuration ? offer?.discountDuration : '',
  description: offer.attributes.filter(attr => attr.type === 'mainFeature').map(attr => attr.value),
  descriptions: sortAsc(offer.attributes.filter(attr => attr.type === 'feature')).map(attr => ({
    value: attr.value,
    icon: attr.icon,
    alt: attr.alt,
  })),
  promotion: offer.promotions,
  moreInfo: sortAsc(offer.attributes.filter(attr => attr.type === 'moreInfo')).map(attr => ({
    value: attr.value,
  })),
  isTVOfferIncluded: offer.isTVOfferIncluded,
  handsetPrice: offer?.equipmentsPrice?.map(price => price.discountedPrice),
  category: offer?.category,
  headerImgDescription: offer.attributes
    .filter(attr => attr.type === 'headerImage')
    .map(attr => attr.description),
});
export function formatAfterPrice(result, simOnly) {
  const offer = result;
  let formattedMoreInfo = [];
  if (
    (result?.price !== result?.afterPriceAmount &&
      result?.afterPricePosition?.[0] === 'more-info') ||
    (result?.afterPricePosition?.[0] === 'more-info' && result?.moreInfo?.length === 0)
  ) {
    const discountDuration = simOnly ? result?.simoDiscountDuration : result?.discountDuration;
    formattedMoreInfo = [
      {
        value: `Price after ${discountDuration} months €${result?.afterPriceAmount} a month excluding annual price increase.`,
      },
      ...result.moreInfo,
    ];
    offer.moreInfo = formattedMoreInfo;
  }

  return offer;
}

export const formatAddOnsData = addOnData => {
  const formattedAddOnData = addOnData?.map(data => ({
    code: data.code,
    image: data.image ? data.image.path : '',
    altText: data.image ? data.image.altText : 'altText',
    mobileImage: data.mobileImage ? data.mobileImage.path : '',
    title: data.description,
    description: data.details,
    price: priceFormatter(data.charges.price),
    serviceGroup: data.serviceGroup,
    AddonsSelected: false,
    orderIndex: data.orderIndex,
  }));
  return formattedAddOnData;
};

export const structureCompatibleAddons = addon => ({
  code: addon.code,
  topTag: addon.attributes.filter(attr => attr.type === 'highlight').map(attr => attr.value),
  preTitle: addon.description?.split(' ').slice(0, 2).join(' '),
  title: addon?.displayName ? addon.displayName : addon.description,
  image: addon?.attributes.filter(attr => attr.type === 'headerImage').map(attr => attr.value),
  singleTariffImage: addon.attributes
    .filter(attr => attr.type === 'singleTariffHeaderImage')
    .map(attr => attr.value),
  singleHeaderImgDescription: addon.attributes
    .filter(attr => attr.type === 'singleTariffHeaderImage')
    .map(attr => attr.description),
  imageActive: addon.attributes
    .filter(attr => attr.type === 'headerImage')
    .map(attr => attr.value.replace(/(\.[^.]+)$/i, '_Active$1')),
  contractTag: addon.attributes.filter(attr => attr.type === 'sash').map(attr => attr.value),
  contractLength: '/month',
  price: (addon?.charges?.price / 100).toFixed(2),
  sash: addon.attributes.filter(attr => attr.type === 'sash').map(attr => attr.value),
  description: addon.attributes.filter(attr => attr.type === 'mainFeature').map(attr => attr.value),
  descriptions: sortAsc(addon.attributes.filter(attr => attr.type === 'feature')).map(attr => ({
    value: attr.value,
    icon: attr.icon,
    alt: attr.alt,
  })),
  headerImgDescription: addon.attributes
    .filter(attr => attr.type === 'headerImage')
    .map(attr => attr.description),
});

export const structureAddons = addon => ({
  code: addon?.code,
  topTag: addon?.attributes?.filter(attr => attr.type === 'highlight').map(attr => attr.value),
  preTitle: addon?.description?.split(' ').slice(0, 2).join(' '),
  title: addon?.displayName ? addon?.displayName : addon?.description,
  image: addon?.attributes?.filter(attr => attr.type === 'headerImage').map(attr => attr.value),
  headerImgDescription: addon?.attributes
    .filter(attr => attr.type === 'headerImage')
    .map(attr => attr.description),
  singleTariffImage: addon?.attributes
    ?.filter(attr => attr.type === 'singleTariffHeaderImage')
    .map(attr => attr.value),
  singleHeaderImgDescription: addon?.attributes
    .filter(attr => attr.type === 'singleTariffHeaderImage')
    .map(attr => attr.description),
  imageActive: addon?.attributes
    ?.filter(attr => attr.type === 'headerImage')
    .map(attr => attr.value.replace(/(\.[^.]+)$/i, '_Active$1')),
  contractTag: addon?.attributes?.filter(attr => attr.type === 'sash').map(attr => attr.value),
  contractLength: '',
  price: (addon?.charges?.price / 100).toFixed(2),
  sash: addon?.attributes?.filter(attr => attr.type === 'sash').map(attr => attr.value),
  description: addon?.attributes
    .filter(attr => attr.type === 'mainFeature')
    .map(attr => attr.value),
  descriptions: sortAsc(addon?.attributes.filter(attr => attr.type === 'feature')).map(attr => ({
    value: attr.value,
    icon: attr.icon,
    alt: attr.alt,
  })),
  handsetPrice: addon?.equipmentPrice?.map(price => price?.discountedPrice),
});

export const formatInsuranceAddOnsData = addOnData => {
  const formattedAddOnData = addOnData?.map(data => ({
    code: data.code,
    image: data.image ? data.image.path : '',
    altText: data.image ? data.image.altText : 'altText',
    mobileImage: data.mobileImage ? data.mobileImage.path : '',
    title: data.displayName,
    description: data.details,
    price: priceFormatter(data.charges?.price),
    serviceGroup: data.serviceGroup,
    AddonsSelected: false,
    orderIndex: data.orderIndex,
  }));
  return formattedAddOnData;
};
export const formatMbbDevicesData = addOnData => {
  const formattedAddOnData = addOnData?.map(data => ({
    code: data.code,
    image: data.image ? data.image : '',
    altText: data.image ? data.imageAltText : 'altText',
    mobileImage: data.mobileImage ? data.mobileImage : '',
    title: data.title,
    description: data.specifications.map(spec => spec.value),
    price: data.price > 0 ? priceFormatter(data.price) : 'Free',
    serviceGroup: 'MBB',
    AddonsSelected: false,
    orderIndex: data.stockLevel,
  }));
  return formattedAddOnData;
};
export default structureData;
